import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { VarnishPopup } from "./VarnishPopup";

export default function VarnishTable() {
   const { loading, data } = useCollection("varnish");
   const columns = [
      {
         title: "Type",
         dataIndex: "type",
         align: "center",
      },
      {
         title: "Costs",
         dataIndex: "costs",
         align: "center",
         sorter: {
            compare: (a, b) => a.costs - b.costs,
         },
      },
      {
         title: "XpretP",
         dataIndex: "xpretp",
         align: "center",
         sorter: {
            compare: (a, b) => a.xpretp - b.xpretp,
         },
      },
      {
         render: (value) => <VarnishPopup title={value.type} costs={value.costs} id={value.id} xpretp={value.xpretp} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
